import type {ReactNode} from "react";
import {cn} from "@/lib/utils";

type Props = {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
};

/** Grouped form section card for premium admin modals. */
export function AdminFormCard({title, description, action, children, className}: Props) {
  return (
    <section className={cn("admin-form-card", className)}>
      <header className="admin-form-card__head">
        <div className="min-w-0">
          <h3 className="admin-form-card__title">{title}</h3>
          {description ? <p className="admin-form-card__desc">{description}</p> : null}
        </div>
        {action ? <div className="admin-form-card__action shrink-0">{action}</div> : null}
      </header>
      <div className="admin-form-card__body">{children}</div>
    </section>
  );
}
